// Section Modules
import { pageHeroBanner } from "../lib/pageHeroBanner";
import { aboutMsc } from "./modules/aboutMsc";
import { textImage } from "../lib/textImage";
import { blueMscLabel } from "./modules/blueMscLabel";
import { longLeftImageVideo } from "./modules/longLeftImageVideo";
import { fullWidth } from "./modules/fullWidth";
import { helper } from "../lib/helper";
import { modalSustain } from "./modules/modal";

// Dependencies
require('fullpage.js/vendors/scrolloverflow');
require('../../../vendors/fullpage.parallax.min.js');
var fullpage = require('fullpage.js/dist/fullpage.extensions.min');
require('fullpage.js/vendors/easings');
require('jquery-watch');


// Fullpage plugin
// var Sustainability;
var counter = 0;

helper.appendFooter();
helper.removeClasser();
// helper.appendBottle();

export const Sustainability = {
  init() {

    counter++;

    //Navigation
    var navList = [];
    var sectionLength = $('.section').length + 1;

    var fullPageNav = $('.js-fullPage-nav');
    var navHTML = '';

    for (let i = 1; i < sectionLength; i++) {
      navList.push('parallax-' + i);
      navHTML = '<a class="fullPage-nav-links" data-menuanchor="parallax-' + i + '"  href="#parallax-' + i + '"></a>';
      if (counter == 1) {
        fullPageNav.append(navHTML);
      }
    }

    let sustainabilityFullpage = new fullpage('#sustainability', {
      // Key
      licenseKey: 'E02B3FBDB98847A6A2FE0582C69F6DC7',

      // Parallax
      parallax: true,
      parallaxKey: 'bW9sbGVycy5jb21fRUFXY0dGeVlXeHNZWGc9NU1B',
      parallaxOptions: { type: 'cover', percentage: 50, property: 'background' },

      // Easing
      css3: true,
      easingcss3: 'cubic-bezier(0.645, 0.045, 0.1, 1)',

      // Scrolling
      scrollingSpeed: 1000,
      autoScrolling: true,
      scrollOverflow: true,
      scrollOverflowReset: true,
      keyboardScrolling: false,
      scrollOverflowOptions: {
        scrollbars: false,
        bounce: false
      },

      anchors: (document.getElementById('sustainability').classList.contains('is-mobile')) ? [] : navList,
      slideNavigation: (document.getElementById('sustainability').classList.contains('is-mobile')) ? false : true,
      menu: '#parallax-nav',

      // events
      onLeave(origin, destination, direction) {

        pageHeroBanner.init(origin, destination, direction, 'onLeave');
        longLeftImageVideo.init(origin, destination, direction, 'onLeave');
        blueMscLabel.init(destination);
        textImage.init(destination);
        fullWidth.init(destination);

        // Special case js
        $('.js-btn-scroll, #fp-nav>ul').addClass('navFade'); // <- adds fade effect on navs

        // <- Match up with the plugins scrollingSpeed
        setTimeout(() => {
          $(origin.item).find('.animated').removeClass('js-animate-completed');
          $(destination.item).find('.animated').addClass('js-animate-completed');
        }, 300);

        helper.scrollIconCtrl(origin, destination, direction);
      },

      afterLoad(origin, destination, direction) {

        pageHeroBanner.init(origin, destination, direction, 'afterLoad');
        longLeftImageVideo.init(origin, destination, direction, 'afterLoad');

        // <- Match up with the plugins scrollingSpeed
        setTimeout(() => {
          $('.js-btn-scroll, #fp-nav>ul').removeClass('navFade'); // <- adds fade effect on navs
          $(destination.item).hasClass('fp-completely') ? $(destination.item).find('.animated').addClass('js-animate-completed') : '';
        }, 1000);

        var nav = document.getElementById('js-head');
        var body = document.getElementsByTagName('body')[0];

        body.classList.add('is-fullpage');

        if (destination.item.classList.contains('js-append-footer')) {
          helper.observer(destination.index);
          let counter = 0;
          $(window).on('mousewheel DOMMouseScroll', function (event) {
            if (destination.item.classList.contains('js-append-footer')) {
              helper.observer(destination.index);
              let deltaY = event.originalEvent.wheelDelta;
              let detailY = event.originalEvent.detail;
              if (deltaY === 120) {
                if ($('.js-append-footer .fp-scroller').css('transform') == 'matrix(1, 0, 0, 1, 0, 0)') {
                  // fullpage_api.moveTo(destination.index);
                  counter++;
                  if (counter > 1 && counter < 2) {
                    window.requestAnimationFrame(function () { fullpage_api.moveSectionUp() });
                  }
                  fullpage_api.setAllowScrolling(true);
                }
              }
            }
          });
        } else {
          fullpage_api.setAllowScrolling(true);
        }

        if (direction == 'down') {
          nav.classList.add('slideUp');
          nav.classList.remove('slideDown');
        } else {
          nav.classList.add('slideDown');
          nav.classList.remove('slideUp');
        }

        function backgroundScroll() {
          var longSection = String(destination.item.className);
          var floatingObj = $('.js-floating-obj');
          var counter = 0;

          floatingObj.css('top', '0');

          if (longSection.indexOf('js-bg-scroll') > 0) {
            $('html').bind('mousewheel DOMMouseScroll', function (e) {
              var delta = (e.originalEvent.wheelDelta || -e.originalEvent.detail);

              if (delta > 0) {
                counter -= 15;
                floatingObj.css('top', counter + 'px');
              } else {
                counter += 15;
                floatingObj.css('top', counter + 'px');
              }
            });
          }
        }

        helper.hasScrollable();
      },
    });

    fullpage_api.setAutoScrolling(true);
    fullpage_api.setAllowScrolling(true);
    fullpage_api.parallax.init()
  },
  observer() {
    setTimeout(() => {
      $(".js-bg-scroll .fp-scroller").watch({
        // specify CSS styles or attribute names to monitor
        properties: "transform",

        // callback function when a change is detected
        callback: function (data, i) {
          let self, styleString;
          self = $(this);
          styleString = self.attr('style');

          if (styleString.includes('translate(0px, 0px)')) {
            window.requestAnimationFrame(function () { fullpage_api.moveSectionUp() });
          }
        }
      });

      $(".boat-section .fp-scroller").watch({
        // specify CSS styles or attribute names to monitor
        properties: "transform",

        // callback function when a change is detected
        callback: function (data, i) {
          let self, styleString;
          self = $(this);
          styleString = self.attr('style');

          if (styleString.includes('translate(0px, 0px)')) {
            window.requestAnimationFrame(function () { fullpage_api.moveSectionUp() });
          }
        }
      });
    }, 200);
  },
  bannerBgMobile() {
    if ($(window).innerWidth() <= 979.98) {

      $('.js-full-banner').css({
        'background-image': `url(${$('.js-full-banner').data('bg')})`
      });

    } else {
      $('.js-full-banner').css({
        'background-image': ``
      });
    }
  },
  boatSectionBgMobile() {
    if ($(window).innerWidth() <= 979.98) {

      $('.js-boat-section').css({
        'background-image': `url(${$('.js-boat-section').data('bg')})`
      });

    } else {
      $('.js-boat-section').css({
        'background-image': ``
      });
    }
  }
}

$(function () {
  let parallaxImage = document.getElementById('parallaxImage');

  $('.js-append-footer').css('top', $('#parallaxImage').css('height'));

  Sustainability.init();
  Sustainability.observer();
  modalSustain.init();

  if (!document.getElementsByClassName('section-padding')[0]) {
    return
  } else {
    document.getElementsByClassName('section-padding')[0].classList.add('section-first');
  }

  // Data bg set
  if (document.getElementById('sustainability').classList.contains('is-mobile')) {
    Sustainability.bannerBgMobile();
    Sustainability.boatSectionBgMobile();
  }
});




// WEBPACK FOOTER //
// ./scripts/components/featured/sustainability/index.js